import { useDispatch, useSelector } from "react-redux";
import { setCurrentStep, setPointerText } from "../../redux";
import {
  getCurrentHotspot,
  getCurrentStep,
  getPointerText,
} from "../../redux/selectors";
import debounce from "lodash.debounce";
import { stripBr } from "../../util/general";
import { steps } from "../../util/constants";
import Section from "../Section/Section";
import { TextField } from "@material-ui/core";

export const ConfigurePointerText = (props) => {
  const dispatch = useDispatch();
  const debouncedDispatch = debounce(dispatch, 400);
  const hotspotIndex = useSelector(getCurrentHotspot);
  const currentStep = useSelector(getCurrentStep);
  const pointerText =
    stripBr(useSelector((state) => getPointerText(state, { hotspotIndex }))) ??
    "";
  const handleTextChange = (e) => {
    const text = e.target.value.replace(/\n/g, "<br/>\n");
    debouncedDispatch(setPointerText({ hotspotIndex, text }));
  };

  return (
    <Section
      title="Spot text"
      onClick={() => dispatch(setCurrentStep(steps.configurePointerText))}
      {...props}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      ></div>
      <div style={{ padding: "0 1rem 0 1rem" }}>
        <TextField
          defaultValue={pointerText} //makes it uncontrolled
          onChange={handleTextChange}
          autoFocus={steps.ConfigurePointerText === currentStep}
          fullWidth
        />
      </div>
    </Section>
  );
};
